import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { PageHeaderComponent } from './page-header/page-header.component';
import { MonPriorityComponent } from './mon-priority/mon-priority.component';
import { CopyDialogComponent } from './copy-dialog/copy-dialog.component';
import { MonCopyComponent } from './mon-copy/mon-copy.component';
import { FormFieldErrorsComponent } from './form-field-errors/form-field-errors.component';
import { IconButtonComponent } from './icon-button/icon-button.component';
import { DocumentDetailsComponent } from './documentdetails/details/document-details.component';
import { PageFixFormSkipToContentOptionsComponent } from './page-fix-form-skip-to-content-options/page-fix-form-skip-to-content-options.component';
import { PageFixFormWizardContainerComponent } from '../modules/page-fix/forms/wizard-container/wizard-container.component';
import { DocumentDetailsDashboardAccessibilityComponent } from './documentdetails/details/dashboard/accessibility/document-details-dashboard-accessibility.component';
import { DocumentDetailsSectionDashboardComponent } from './documentdetails/details/dashboard/dashboard.component';
import { PageFixFormWizardContainerFooterOptionsComponent } from '../modules/page-fix/forms/wizard-container/footers/options/options.component';
import { DocumentDetailsSectionAccessibilityComponent } from './documentdetails/details/accessibility/document-details-section-accessibility.component';
import { PageFixFormWizardContainerFooterGoToOptionsComponent } from '../modules/page-fix/forms/wizard-container/footers/go-to-options/go-to-options.component';
import { PageFixFormSkipToContentComponent } from '../modules/page-fix/forms/skip-to-content/skip-to-content.component';
import { CommonModule } from '@angular/common';
import {
    NgbTooltipModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbPaginationModule,
    NgbPopover,
} from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '../modules/translate.module';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { UpgradePipeModule } from '../filters/upgrade-pipe.module';
import { PageFixFormInfoViewComponent } from '@client/app/modules/page-fix/forms/info-view/info-view.component';
import { PageFixFormMisspellingComponent } from '@client/app/modules/page-fix/forms/misspelling/page-fix-form-misspelling.component';
import { PageFixFormBrokenLinkComponent } from '@client/app/modules/page-fix/forms/broken-link/page-fix-form-broken-link.component';
import { PageFixFormEditAltTextComponent } from '@client/app/modules/page-fix/forms/edit-alt-text/page-fix-form-edit-alt-text.component';
import { PageFixFormNewWindowOptionsComponent } from '@client/app/modules/page-fix/forms/new-window/options/page-fix-form-new-window-options.component';
import { PageFixFormNewWindowComponent } from '../modules/page-fix/forms/new-window/page-fix-form-new-window.component';
import {
    MonEventTriggerModule,
    MonTableSortModule,
    TableModule,
    LayoutModule, MonDatePickerModule,
} from '@monsido/angular-shared-components';
import { AngularSelectorComponent } from './angular-selector/angular-selector.component';
import { PageFixFormMarqueeOptionsComponent } from '../modules/page-fix/forms/marquee/options/page-fix-form-marquee-options.component';
import { PageFixFormMarqueeComponent } from '../modules/page-fix/forms/marquee/page-fix-form-marquee.component';
import { PageFixFormBoldOptionsComponent } from '../modules/page-fix/forms/bold/options/page-fix-form-bold-options.component';
import { PageFixFormBoldComponent } from '../modules/page-fix/forms/bold/page-fix-form-bold.component';
import { PageFixFormBlinkOptionsComponent } from '../modules/page-fix/forms/blink/options/page-fix-form-blink-options.component';
import { PageFixFormBlinkComponent } from '../modules/page-fix/forms/blink/page-fix-form-blink.component';
import { PageFixFormItalicOptionsComponent } from '../modules/page-fix/forms/italic/options/page-fix-form-italic-options.component';
import { PageFixFormItalicComponent } from '../modules/page-fix/forms/italic/page-fix-form-italic.component';
import { PageFixFormCustomComponent } from '../modules/page-fix/forms/custom/page-fix-form-custom.component';
import { TablePageSizeComponent } from './table-page-size/table-page-size.component';
import { TableSearchComponent } from './table-search/table-search.component';
import { FilterButtonComponent } from '@client/deprecate/frontend-components/src/js/components/layout/filter-button/filter-button.component';
import { MonTabsComponent } from '@client/deprecate/frontend-components/src/js/components/tabs/mon-tabs.component';
import { VisitsComponent } from '@client/deprecate/frontend-components/src/js/components/layout/visits/visits.component';
import { LanguageComponent } from './language/language.component';
import { PagesButtonComponent } from './pages-button/pages-button.component';
import {
    AccessibilityTableFilterSelectorItemTemplateComponent,
} from '@client/app/pages/accessibility/templates/accessibility-table-filter-selector-item-template.component';
import { TableFiltersSelectorItemComponent } from './table-filters-selector-item/table-filters-selector-item.component';
import { TableFiltersSelectorComponent } from './table-filters-selector/table-filters-selector.component';
import { TableFiltersComponent } from './table-filters/table-filters.component';
import { TableContainerPagerComponent } from './table-container-pager/table-container-pager.component';
import { TableContainerComponent } from './table-container/table-container.component';
import { TableSelectItemComponent } from './table-select-item/table-select-item.component';
import { TableSelectItemAllComponent } from './table-select-item-all/table-select-item-all.component';
import { IndeterminateDirective } from '../directives/indeterminate.directive';
import { MonSetBackgroundColorDirective } from '../directives/set-background-color/set-background-color.directive';
import { FormFieldInputComponent } from './form-field-input/form-field-input.component';
import { FormFieldCheckboxComponent } from './form-field-checkbox/form-field-checkbox.component';
import { FormFieldCheckboxInLineComponent } from './form-field-checkbox-in-line/form-field-checkbox-in-line.component';
import { FormFieldTextareaComponent } from './form-field-textarea/form-field-textarea.component';
import { FormFieldSelectComponent } from './form-field-select/form-field-select.component';
import { SelectCountriesComponent } from './select-countries/select-countries.component';
import { SelectTimezonesComponent } from './select-timezones/select-timezones.component';
import { FormFieldMaterialSwitchComponent } from './form-field-material-switch/form-field-material-switch.component';
import { FormFieldRadioInLineComponent } from './form-field-radio-in-line/form-field-radio-in-line.component';
import { FormFieldRadioNewLineComponent } from './form-field-radio-new-line/form-field-radio-new-line.component';
import { TableDateComponent } from './table-date/table-date.component';
import { TableComplianceComponent } from './table-compliance/table-compliance.component';
import { DoughnutComponent } from '@client/app/modules/charts/components/doughnut.component';
import { MonPanelHeaderComponent } from './mon-panel-header/mon-panel-header.component';
import { MonPanelComponent } from './mon-panel/mon-panel.component';
import { UserDateComponent } from './user-date/user-date.component';
import { DocumentsButtonComponent } from './documents-button.component';
import { IconCircleComponent } from './icon-circle.component';
import { NotificationComponent } from './notification.component';
import { NotificationChangeComponent } from './notification-change.component';
import { NotificationTextComponent } from './notification-text/notification-text.component';
import { MonSpinnerSnakeComponent } from './mon-spinner-snake/mon-spinner-snake.component';
import { UrlTitleComponent } from './url-title/url-title.component';
import { TablePageDetailsComponent } from './table-page-details/table-page-details.component';
import { TableDocumentDetailsComponent } from './documentdetails/table-document-details.component';
import { UrlTitlePageDetailsComponent } from './pagedetails/components/url-title/url-title-page-details.component';
import { UrlTitleDocumentDetailsComponent } from './url-title-document-details/url-title-document-details.component';
import { NotificationDropdownComponent } from './notification-dropdown/notification-dropdown.component';
import { PagesTableComponent } from './pages/pages-table.component';
import { ExtensionModule } from '@client/app/modules/extension/extension.module';
import { MonChartDashboardComponent } from './mon-chart-dashboard/mon-chart-dashboard.component';
import { MonScoreComponentsModule } from '@client/app/modules/score/components/mon-score-components.module';
import { LineComponent } from '@client/app/modules/charts/components/line.component';
import { TableCssComplianceComponent } from './css-compliance/table-css-compliance.component';
import { SimpleDoughnutChartModule } from '@client/ng2/shared/components/simple-doughnut-chart/simple-doughnut-chart.module';
import {
    ColorSimplePickerComponent,
} from '@client/app/forms/domain-script-guide/components/color-picker/color-simple-picker.component';
import { CompactPickerComponent } from '@iplab/ngx-color-picker';
import {
    NgClickOutsideDelayOutsideDirective,
    NgClickOutsideDirective,
    NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';
import { LabelContainerSelectorComponent } from './label-container-selector/label-container-selector.component';
import { LabelContainerComponent } from './label-container/label-container.component';
import { LabelTableComponent } from './label-table/label-table.component';
import { PagesFilesComponent } from './pages/files/pages-files.component';
import { PagesFilesPagesComponent } from './pages/files/pages/pages.component';
import { ExportModule } from '@client/app/modules/export/export.module';
import { AccGuidelineDescriptionComponent } from '@client/app/modules/accessibility/components/guideline-description/guideline-description.component';
import { AccHelpCenterBtnComponent } from '@client/app/modules/accessibility/components/help-center-btn/help-center-btn.component';
import { AccResponsibilitiesComponent } from '@client/app/modules/accessibility/components/responsibilities/responsibilities.component';
import { FastTrackTableComponent } from '@client/app/modules/fast-track/table/fast-track-table.component';
import { FastTrackInformationComponent } from '@client/app/modules/fast-track/information/fast-track-information.component';
import {
    AccessibilityDialogsHelpCenterComponent,
} from '@client/app/modules/accessibility/dialogs/help-center/help-center.component';
import { TablePolicyTypeComponent } from '@monsido/modules/table-policy-type/table-policy-type.component';
import {
    FastTrackDialogsPagesComponent,
} from '@client/app/modules/accessibility/dialogs/fast-track-pages/fast-track-pages.component';
import {
    AccessibilityDialogsNewHelpCenterDecisionTreeComponent,
} from '@client/app/modules/accessibility/dialogs/new-help-center/decision-tree/decision-tree.component';
import {
    AccessibilityDialogsNewHelpCenterComponent,
} from '@client/app/modules/accessibility/dialogs/new-help-center/new-help-center.component';
import { AccDocPdfAccessibilityRemediationBtnComponent } from '@client/app/modules/accessibility/document/pdf-accessibility/remediation/acc-doc-pdf-accessibility-remediation-btn.component';
import { AccDocPdfAccessibilityMultipleRemediationsBtnComponent } from '@client/app/modules/accessibility/document/pdf-accessibility/remediation/acc-doc-pdf-accessibility-multiple-remediations-btn.component';
import { PageFixIconComponent } from '@client/app/modules/page-fix/components/icon/page-fix-icon.component';
import { PageFixChangesetAccessibilityComponent } from '@client/app/modules/page-fix/components/changeset/accessibility/page-fix-changeset-accessibility.component';
import { PageFixChangesetLinkComponent } from '@client/app/modules/page-fix/components/changeset/link/page-fix-changeset-link.component';
import { PageFixChangesetSpellingComponent } from '@client/app/modules/page-fix/components/changeset/spelling/page-fix-changeset-spelling.component';
import { AccessibilityFastTrackComponent } from '@client/app/modules/accessibility/dialogs/fast-track/accessibility-fast-track.component';
import { MonActionMenuModule } from '@client/ng2/shared/components/action-menu/action-menu.module';
import { AccessibilityDashboardComplianceBarComponent } from '@client/app/pages/accessibility/dashboard/compliance/bar/accessibility-dashboard-compliance-bar.component';
import { AccessibilityDashboardComplianceDoughnutProgressbarComponent } from '@client/app/pages/accessibility/dashboard/compliance/doughnut/progressbar/accessibility-dashboard-compliance-doughnut-progressbar.component';
import { AccessibilityDashboardComplianceDoughnutComponent } from '@client/app/pages/accessibility/dashboard/compliance/doughnut/accessibility-dashboard-compliance-doughnut.component';
import {
    AccessibilityDashboardDistributionComponent,
} from '@client/app/pages/accessibility/dashboard/distribution/accessibility-dashboard-distribution.component';
import { AccessibilityDashboardComplianceComponent } from '@client/app/pages/accessibility/dashboard/compliance/accessibility-dashboard-compliance.component';
import { AccessibilityDashboardPdfDoughnutComponent } from '@client/app/pages/accessibility/dashboard/pdf/doughnut/accessibility-dashboard-pdf-doughnut.component';
import {
    QuickHelpComplianceStatusModule,
} from '@client/app/components/quick-help-compliance-status/quick-help-compliance-status.module';
import { UIRouterModule } from '@uirouter/angular';
import { AccessibilityDashboardPdfComponent } from '@client/app/pages/accessibility/dashboard/pdf/accessibility-dashboard-pdf.component';
import { AccessibilityDashboardDoughnutComponent } from '@client/app/pages/accessibility/dashboard/summary/doughnut/accessibility-dashboard-doughnut.component';
import { AccessibilitySummaryLineChartComponent } from '@client/app/pages/accessibility/dashboard/summary/line-chart/accessibility-summary-line-chart.component';
import { AccessibilityDashboardNotificationsComponent } from '@client/app/pages/accessibility/dashboard/summary/notifications/accessibility-dashboard-notifications.component';
import { AccessibilityDashboardSummaryComponent } from '@client/app/pages/accessibility/dashboard/summary/accessibility-dashboard-summary.component';
import {
    AccessibilityDashboardComponent,
} from '@client/app/pages/accessibility/dashboard/accessibility-dashboard.component';
import { PagePerformanceScoreDoughnutChartComponent } from '@client/app/modules/page-performance/components/charts/score-doughnut/page-performance-score-doughnut-chart.component';
import { PagePerformanceScoreIndicatorsComponent } from '@client/app/modules/page-performance/components/score-indicators/page-performance-score-indicators.component';
import { PolicyInformationComponent } from './policy-information/policy-information.component';
import { MonFlagIconComponent } from '@client/app/modules/flags/components/flag.component';
import { BrokenTableComponent } from './pages/broken/broken-table.component';
import { PageLinkDropdownAllComponent } from './page-link-dropdown/all/page-link-dropdown-all.component';
import { PageLinkDropdownComponent } from './page-link-dropdown/page-link-dropdown.component';
import { TableDictionaryAllComponent } from './dictionary/all/table-dictionary-all.component';
import { PagesMisspellingsTableComponent } from './pages/misspellings/pages-misspellings-table.component';
import { TableDictionaryComponent } from '@client/app/components/dictionary/dictionary.component';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import { PageDetailsSectionsTabsComponent } from './pagedetails/tabs/page-details-sections-tabs.component';
import { SopButtonComponent } from './pagedetails/details/sop/sop-button.component';
import { PageDetailsSectionAccessibilityInformationFastTrackComponent } from './pagedetails/details/sections/accessibility/information/fast-track/page-details-section-accessibility-information-fast-track.component';
import { DocumentDetailsAccessibilityInformationComponent } from './documentdetails/details/accessibility/information/information.component';
import { DocumentDetailsAccessibilityWcag20TableComponent } from './documentdetails/details/accessibility/wcag20-table/wcag20-table.component';
import { PageDetailsSectionAccessibilityInformationComponent } from './pagedetails/details/sections/accessibility/information/page-details-section-accessibility-information.component';
import { PageAccessibilityWcag20TableComponent } from './pagedetails/details/sections/accessibility/wcag2-0/table/page-accessibility-wcag2-0-table.component';
import { PageAccessibilityWcag20Component } from './pagedetails/details/sections/accessibility/wcag2-0/page-accessibility-wcag2-0.component';
import { PageAccessibilityWcag21Component } from './pagedetails/details/sections/accessibility/wcag2-1/page-accessibility-wcag2-1.component';
import { PageAccessibilityWcag22Component } from './pagedetails/details/sections/accessibility/wcag2-2/page-accessibility-wcag2-2.component';
import { PageDetailsSectionAccessibilityComponent } from './pagedetails/details/sections/accessibility/accessibility.component';
import { PageDetailsSectionDashboardBlocksOverviewComponent } from './pagedetails/details/sections/dashboard/blocks/overview/overview.component';
import { PageDetailsDashboardChartsAccessibilityComponent } from './pagedetails/details/sections/dashboard/charts/accessibility/page-details-dashboard-charts-accessibility.component';
import { PageDetailsModule } from '@monsido/modules/page-details/page-details.module';
import { PageDetailsDashboardChartsPagePerformanceComponent } from './pagedetails/details/sections/dashboard/charts/page-performance/page-details-dashboard-charts-page-performance.component';
import { PageDetailsDashboardChartsPoliciesComponent } from './pagedetails/details/sections/dashboard/charts/policies/page-details-dashboard-charts-policies.component';
import { PageDetailsDashboardChartsQaComponent } from './pagedetails/details/sections/dashboard/charts/qa/page-details-dashboard-charts-qa.component';
import { PageDetailsDashboardChartsSeoComponent } from './pagedetails/details/sections/dashboard/charts/seo/page-details-dashboard-charts-seo.component';
import { PageDetailsSectionInventoryDashboardComponent } from './pagedetails/details/sections/inventory/dashboard/page-details-section-inventory-dashboard.component';
import { PageDetailsDashboardChartsStatisticsComponent } from './pagedetails/details/sections/dashboard/charts/statistics/page-details-dashboard-charts-statistics.component';
import { PageDetailsSectionDashboardComponent } from './pagedetails/details/sections/dashboard/dashboard.component';
import { PageDetailsSectionInventoryHeaderComponent } from './pagedetails/details/sections/inventory/subsections/header/page-details-section-inventory-header.component';
import { PageDetailsSectionInventoryIncominglinksComponent } from './pagedetails/details/sections/inventory/subsections/incominglinks/page-details-section-inventory-incominglinks.component';
import { PageDetailsSectionInventoryLinksComponent } from './pagedetails/details/sections/inventory/subsections/links/links.component';
import { PageDetailsSectionInventoryMetadataComponent } from './pagedetails/details/sections/inventory/subsections/metadata/metadata.component';
import { PageDetailsSectionInventoryComponent } from './pagedetails/details/sections/inventory/page-details-section-inventory.component';
import { PageDetailsSectionPagePerformanceComponent } from './pagedetails/details/sections/page-performance/page-details-section-page-performance.component';
import { PageDetailsPolicyInformationImageComponent } from './pagedetails/details/sections/policies/policy-information/image/image.component';
import { PageDetailsPolicyInformationComponent } from './pagedetails/details/sections/policies/policy-information/page-details-policy-information.component';
import { PageDetailsPoliciesTableComponent } from './pagedetails/details/sections/policies/table/page-details-policies-table.component';
import { PageDetailsSectionPoliciesComponent } from './pagedetails/details/sections/policies/page-details-section-policies.component';
import { PageDetailsBrokenlinksTableComponent } from './pagedetails/details/sections/qa/subsections/broken/table/page-details-brokenlinks-table.component';
import { PageDetailsSectionQaBrokenComponent } from './pagedetails/details/sections/qa/subsections/broken/page-details-section-qa-broken.component';
import { PageDetailsSectionQaIgnoredSpellComponent } from './pagedetails/details/sections/qa/subsections/ignored-spell/page-details-section-qa-ignored-spell.component';
import { PageDetailsSectionQaLanguageMatchComponent } from './pagedetails/details/sections/qa/subsections/language-match/page-details-section-qa-language-match.component';
import { LanguagesModule } from '@client/app/modules/languages-ng2/languages.module';
import { PageDetailsSectionQaReadabilityComponent } from './pagedetails/details/sections/qa/subsections/readability/page-details-section-qa-readability.component';
import { PageDetailsSectionQaSpellComponent } from './pagedetails/details/sections/qa/subsections/spell/page-details-section-qa-spell.component';
import { PageDetailsSectionQaComponent } from './pagedetails/details/sections/qa/page-details-section-qa.component';
import { PageDetailsSeoPagesPagesDialogComponent } from './pagedetails/details/sections/seo/seo-information/pages/page-details-seo-pages-dialog.component';
import { SeoInformationDuplicateH1Component } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/duplicate-h1/seo-information-duplicate-h1.component';
import { SeoInformationDuplicateTitleComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/duplicate-title/seo-information-duplicate-title.component';
import { SeoInformationMissingAltComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-alt/seo-information-missing-alt.component';
import { SeoInformationMissingH1Component } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-h1/seo-information-missing-h1.component';
import { SeoInformationMissingMetaDescriptionComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-meta-description/seo-information-missing-meta-description.component';
import { SeoInformationMissingMetaKeywordComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-meta-keyword/seo-information-missing-meta-keyword.component';
import { SeoInformationMissingSubheadlinesComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-subheadlines/seo-information-missing-subheadlines.component';
import { SeoInformationMissingTitleComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/missing-title/seo-information-missing-title.component';
import { SeoInformationMultipleH1Component } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/multiple-h1/seo-information-multiple-h1.component';
import { SeoInformationNoFollowComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/no-follow/seo-information-no-follow.component';
import { SeoInformationNoIndexComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/no-index/seo-information-no-index.component';
import { SeoInformationTooLongMetaDescriptionComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/too-long-meta-description/seo-information-too-long-meta-description.component';
import { SeoInformationTooLongUrlComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/too-long-url/seo-information-too-long-url.component';
import { SeoInformationTooManyPageLinksComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/too-many-page-links/seo-information-too-many-page-links.component';
import { SeoInformationTooShortMetaDescriptionComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/issues/too-short-meta-description/seo-information-too-short-meta-description.component';
import { SeoInformationInformationComponent } from './pagedetails/details/sections/seo/seo-information/sections/information/seo-information-information.component';
import { SeoInformationQuickHelpComponent } from './pagedetails/details/sections/seo/seo-information/sections/quick-help/seo-information-quick-help.component';
import { QuickHelpTranslationsComponent } from './pagedetails/details/sections/seo/seo-information/sections/quick-help/translations/translations.component';
import { PageDetailsSeoInformationComponent } from './pagedetails/details/sections/seo/seo-information/page-details-seo-information.component';
import { PageDetailsSeoTableComponent } from './pagedetails/details/sections/seo/table/page-details-seo-table.component';
import { PageDetailsSectionSeoComponent } from './pagedetails/details/sections/seo/page-details-section-seo.component';
import { PageDetailsSectionStatisticsSummaryComponent } from './pagedetails/details/sections/statistics/summary/page-details-section-statistics-summary.component';
import { PageDetailsSectionStatisticsTrafficSourcesComponent } from './pagedetails/details/sections/statistics/traffic-sources/page-details-section-statistics-traffic-sources.component';
import {
    PageDetailsDashboardChartsDataPrivacyComponent,
} from '@client/app/modules/data-privacy/components/pagedetails/dashboard/chart/page-details-dashboard-charts-data-privacy.component';
import {
    PagePerformanceProfileDropdownComponent,
} from '@client/app/modules/page-performance/components/profile-dropdown/page-performance-profile-dropdown.component';
import {
    PagePerformancePageDetailsDashboardComponent,
} from '@client/app/modules/page-performance/page-details/dashboard/dashboard.component';
import {
    PagePerformancePageDetailsOpportunitiesComponent,
} from '@client/app/modules/page-performance/page-details/opportunities/opportunities.component';
import {
    PagePerformancePageDetailsDiagnosticsComponent,
} from '@client/app/modules/page-performance/page-details/diagnostics/diagnostics.component';
import {
    PagePerformancePageDetailsHistoryComponent,
} from '@client/app/modules/page-performance/page-details/history/history.component';
import { ActiveFeaturePipe } from '@monsido/core/pipes/active-feature/active-feature.pipe';
import {
    StatisticsInformationComponent,
} from '@client/app/pages/statistics/components/statistics-information.component';
import { BarComponent } from '@client/app/modules/charts/components/bar.component';
import {
    StatisticsDistributionComponent,
} from '@client/app/pages/statistics/components/statistics-distribution.component';
import {
    PageDetailsSectionStatisticsComponent,
} from '@client/app/components/pagedetails/details/sections/statistics/page-details-section-statistics.component';
import { PageDetailsComponent } from './pagedetails/details/page-details.component';
import { SharedPipesModule } from '@client/ng2/shared/pipes/shared-pipes.module';
import {
    PageDetailsSectionDataPrivacyComponent,
} from '@client/app/modules/data-privacy/components/pagedetails/page-details-section-data-privacy.component';
import {
    MonDataPrivacyInfoTypeIconModule,
} from '@monsido/modules/data-privacy/components/info-type-icon/info-type-icon.module';
import { DataPrivacyModule } from '@monsido/modules/data-privacy/data-privacy.module';
import { MonDataPrivacyDropdownComponent } from '@monsido/modules/data-privacy/components/dropdown/dropdown.component';
import {
    PageDetailsCookieAcceptanceRateComponent,
} from '@client/app/modules/cookie-banner/pagedetails/cookie-acceptance-rate/page-details-cookie-acceptance-rate.component';
import {
    PagePerformanceScoreLineChartComponent,
} from '@client/app/modules/page-performance/components/charts/score-line/page-performance-score-line-chart.component';
import {
    PagePerformanceOpportunitiesByImpactComponent,
} from '@client/app/modules/page-performance/components/charts/opportunities-by-impact/opportunities-by-impact.component';
import {
    PagePerformancePageDetailsLoadSequenceComponent,
} from '@client/app/modules/page-performance/page-details/dashboard/load-sequence/load-sequence.component';
import {
    PagePerformancePageDetailsLoadTimesTrendComponent,
} from '@client/app/modules/page-performance/page-details/dashboard/load-times-trend/load-times-trend.component';
import { MarkdownViewerComponent } from '@client/app/components/markdown-viewer/markdown-viewer.component';
import {
    DomainDashboardDataPrivacyComponent,
} from '@client/app/modules/data-privacy/components/domain-dashboard-card/domain-dashboard-data-privacy.component';
import { PinDomainComponent } from './pin-domain/pin-domain.component';
import { FaviconWrapperComponent } from '@layout/favicon-wrapper/favicon-wrapper.component';
import { LoginComponent } from '../pages/login/login/login.component';
import { ScanDetailsDialogComponent } from './dialogs/scan-details/scan-details.component';
import { NgCsvDirective } from '@client/app/directives/ng-csv.directive';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';
import {
    PageDetailsSectionAccessibilityInformationContentComponent,
} from '@client/app/components/pagedetails/details/sections/accessibility/information/page-details-section-accessibility-information-content.component';
import { JiraIssueButtonsComponent } from '@client/app/feature-modules/jira-connector/components/jira-issue-buttons.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        NgbTooltipModule,
        NgbDropdownModule,
        TranslateModule,
        FormsModule,
        HttpClientModule,
        UpgradePipeModule,
        // LayoutModule,
        NgbProgressbarModule,
        NgbPaginationModule,
        DoughnutComponent,
        MonEventTriggerModule,
        TableModule,
        MonTableSortModule,
        ExtensionModule,
        MonScoreComponentsModule,
        LineComponent,
        LayoutModule,
        SimpleDoughnutChartModule,
        CompactPickerComponent,
        NgClickOutsideDelayOutsideDirective,
        NgClickOutsideDirective,
        ExportModule,
        TablePolicyTypeComponent,
        NgbPopover,
        MonActionMenuModule,
        QuickHelpComplianceStatusModule,
        UIRouterModule,
        NgClickOutsideExcludeDirective,
        ModalsDirectivesModule,
        PageDetailsModule,
        QuickHelpTranslationsComponent,
        ActiveFeaturePipe,
        BarComponent,
        MonDatePickerModule,
        SharedPipesModule,
        MonDataPrivacyInfoTypeIconModule,
        DataPrivacyModule,
        MonDataPrivacyDropdownComponent,
        MarkdownViewerComponent,
        FaviconWrapperComponent,
        NgCsvDirective,
        DatePickerComponent,
        JiraIssueButtonsComponent,
        LanguagesModule,
    ],
    declarations: [
        ColorSimplePickerComponent,
        PageHeaderComponent,
        MonPriorityComponent,
        CopyDialogComponent,
        MonCopyComponent,
        FormFieldErrorsComponent,
        IconButtonComponent,
        DocumentDetailsComponent,
        PageFixFormInfoViewComponent,
        PageFixFormMisspellingComponent,
        PageFixFormBrokenLinkComponent,
        PageFixFormEditAltTextComponent,
        PageFixFormNewWindowOptionsComponent,
        PageFixFormNewWindowComponent,
        PageFixFormSkipToContentOptionsComponent,
        PageFixFormWizardContainerComponent,
        PageFixFormWizardContainerFooterOptionsComponent,
        PageFixFormWizardContainerFooterGoToOptionsComponent,
        PageFixFormSkipToContentComponent,
        AngularSelectorComponent,
        PageFixFormMarqueeOptionsComponent,
        DocumentDetailsSectionAccessibilityComponent,
        DocumentDetailsDashboardAccessibilityComponent,
        DocumentDetailsSectionDashboardComponent,
        PageFixFormMarqueeComponent,
        PageFixFormBoldOptionsComponent,
        PageFixFormBoldComponent,
        PageFixFormBlinkOptionsComponent,
        PageFixFormBlinkComponent,
        PageFixFormItalicOptionsComponent,
        PageFixFormItalicComponent,
        PageFixFormCustomComponent,
        TablePageSizeComponent,
        TableSearchComponent,
        FilterButtonComponent,
        MonTabsComponent,
        VisitsComponent,
        LanguageComponent,
        PagesButtonComponent,
        AccessibilityTableFilterSelectorItemTemplateComponent,
        TableFiltersSelectorItemComponent,
        TableFiltersSelectorComponent,
        TableFiltersComponent,
        TableContainerPagerComponent,
        TableContainerComponent,
        TableSelectItemComponent,
        TableSelectItemAllComponent,
        IndeterminateDirective,
        MonSetBackgroundColorDirective,
        FormFieldInputComponent,
        FormFieldCheckboxComponent,
        FormFieldCheckboxInLineComponent,
        FormFieldTextareaComponent,
        FormFieldSelectComponent,
        SelectCountriesComponent,
        SelectTimezonesComponent,
        FormFieldMaterialSwitchComponent,
        FormFieldRadioInLineComponent,
        FormFieldRadioNewLineComponent,
        TableDateComponent,
        TableComplianceComponent,
        MonPanelHeaderComponent,
        MonPanelComponent,
        UserDateComponent,
        DocumentsButtonComponent,
        IconCircleComponent,
        NotificationComponent,
        NotificationChangeComponent,
        NotificationTextComponent,
        MonSpinnerSnakeComponent,
        UrlTitleComponent,
        TablePageDetailsComponent,
        TableDocumentDetailsComponent,
        UrlTitlePageDetailsComponent,
        UrlTitleDocumentDetailsComponent,
        NotificationDropdownComponent,
        PagesTableComponent,
        MonChartDashboardComponent,
        TableCssComplianceComponent,
        LabelContainerSelectorComponent,
        LabelContainerComponent,
        LabelTableComponent,
        PagesFilesComponent,
        PagesFilesPagesComponent,
        IconButtonComponent,
        AccGuidelineDescriptionComponent,
        AccHelpCenterBtnComponent,
        AccResponsibilitiesComponent,
        FastTrackTableComponent,
        FastTrackInformationComponent,
        AccessibilityDialogsHelpCenterComponent,
        FastTrackDialogsPagesComponent,
        AccessibilityDialogsNewHelpCenterDecisionTreeComponent,
        AccessibilityDialogsNewHelpCenterComponent,
        AccDocPdfAccessibilityRemediationBtnComponent,
        AccDocPdfAccessibilityMultipleRemediationsBtnComponent,
        PageFixIconComponent,
        PageFixChangesetAccessibilityComponent,
        PageFixChangesetLinkComponent,
        PageFixChangesetSpellingComponent,
        AccessibilityFastTrackComponent,
        AccessibilityDashboardComplianceBarComponent,
        AccessibilityDashboardComplianceDoughnutProgressbarComponent,
        AccessibilityDashboardComplianceDoughnutComponent,
        AccessibilityDashboardComplianceComponent,
        AccessibilityDashboardPdfDoughnutComponent,
        AccessibilityDashboardDistributionComponent,
        AccessibilityDashboardPdfComponent,
        AccessibilityDashboardDoughnutComponent,
        AccessibilitySummaryLineChartComponent,
        AccessibilityDashboardNotificationsComponent,
        AccessibilityDashboardSummaryComponent,
        AccessibilityDashboardComponent,
        PagePerformanceScoreDoughnutChartComponent,
        PagePerformanceScoreIndicatorsComponent,
        PolicyInformationComponent,
        MonFlagIconComponent,
        BrokenTableComponent,
        PageLinkDropdownAllComponent,
        PageLinkDropdownComponent,
        TableDictionaryComponent,
        TableDictionaryAllComponent,
        PagesMisspellingsTableComponent,
        PageDetailsSectionsTabsComponent,
        SopButtonComponent,
        PageDetailsSectionAccessibilityInformationFastTrackComponent,
        PageDetailsSectionAccessibilityInformationContentComponent,
        DocumentDetailsAccessibilityInformationComponent,
        DocumentDetailsAccessibilityWcag20TableComponent,
        PageDetailsSectionAccessibilityInformationComponent,
        PageAccessibilityWcag20TableComponent,
        PageAccessibilityWcag20Component,
        PageAccessibilityWcag21Component,
        PageAccessibilityWcag22Component,
        PageDetailsSectionAccessibilityComponent,
        PageDetailsSectionDashboardBlocksOverviewComponent,
        PageDetailsDashboardChartsAccessibilityComponent,
        PageDetailsDashboardChartsPagePerformanceComponent,
        PageDetailsDashboardChartsPoliciesComponent,
        PageDetailsDashboardChartsQaComponent,
        PageDetailsDashboardChartsSeoComponent,
        PageDetailsSectionInventoryDashboardComponent,
        PageDetailsDashboardChartsStatisticsComponent,
        PageDetailsSectionDashboardComponent,
        PageDetailsSectionInventoryHeaderComponent,
        PageDetailsSectionInventoryIncominglinksComponent,
        PageDetailsSectionInventoryLinksComponent,
        PageDetailsSectionInventoryMetadataComponent,
        PageDetailsSectionInventoryComponent,
        PageDetailsSectionPagePerformanceComponent,
        PageDetailsPolicyInformationImageComponent,
        PageDetailsPolicyInformationComponent,
        PageDetailsPoliciesTableComponent,
        PageDetailsSectionPoliciesComponent,
        PageDetailsBrokenlinksTableComponent,
        PageDetailsSectionQaBrokenComponent,
        PageDetailsSectionQaIgnoredSpellComponent,
        PageDetailsSectionQaLanguageMatchComponent,
        PageDetailsSectionQaReadabilityComponent,
        PageDetailsSectionQaSpellComponent,
        PageDetailsSectionQaComponent,
        PageDetailsSeoPagesPagesDialogComponent,
        SeoInformationDuplicateH1Component,
        SeoInformationDuplicateTitleComponent,
        SeoInformationMissingAltComponent,
        SeoInformationMissingH1Component,
        SeoInformationMissingMetaDescriptionComponent,
        SeoInformationMissingMetaKeywordComponent,
        SeoInformationMissingSubheadlinesComponent,
        SeoInformationMissingTitleComponent,
        SeoInformationMultipleH1Component,
        SeoInformationNoFollowComponent,
        SeoInformationNoIndexComponent,
        SeoInformationTooLongMetaDescriptionComponent,
        SeoInformationTooLongUrlComponent,
        SeoInformationTooManyPageLinksComponent,
        SeoInformationTooShortMetaDescriptionComponent,
        SeoInformationInformationComponent,
        SeoInformationQuickHelpComponent,
        PageDetailsSeoInformationComponent,
        PageDetailsSeoTableComponent,
        PageDetailsSectionSeoComponent,
        PageDetailsSectionStatisticsSummaryComponent,
        PageDetailsSectionStatisticsTrafficSourcesComponent,
        PageDetailsDashboardChartsDataPrivacyComponent,
        PagePerformanceProfileDropdownComponent,
        PagePerformancePageDetailsDashboardComponent,
        PagePerformancePageDetailsOpportunitiesComponent,
        PagePerformancePageDetailsDiagnosticsComponent,
        PagePerformancePageDetailsHistoryComponent,
        StatisticsInformationComponent,
        StatisticsDistributionComponent,
        PageDetailsSectionStatisticsComponent,
        PageDetailsComponent,
        PageDetailsSectionDataPrivacyComponent,
        PageDetailsCookieAcceptanceRateComponent,
        PagePerformanceScoreLineChartComponent,
        PagePerformanceOpportunitiesByImpactComponent,
        PagePerformancePageDetailsLoadSequenceComponent,
        PagePerformancePageDetailsLoadTimesTrendComponent,
        DomainDashboardDataPrivacyComponent,
        PinDomainComponent,
        LoginComponent,
        ScanDetailsDialogComponent,
    ],
    exports: [
        ColorSimplePickerComponent,
        PageHeaderComponent,
        MonPriorityComponent,
        CopyDialogComponent,
        MonCopyComponent,
        FormFieldErrorsComponent,
        IconButtonComponent,
        DocumentDetailsComponent,
        PageFixFormInfoViewComponent,
        PageFixFormMisspellingComponent,
        PageFixFormBrokenLinkComponent,
        PageFixFormEditAltTextComponent,
        PageFixFormNewWindowOptionsComponent,
        PageFixFormNewWindowComponent,
        PageFixFormSkipToContentOptionsComponent,
        PageFixFormWizardContainerComponent,
        PageFixFormWizardContainerFooterOptionsComponent,
        PageFixFormWizardContainerFooterGoToOptionsComponent,
        PageFixFormSkipToContentComponent,
        AngularSelectorComponent,
        PageFixFormMarqueeOptionsComponent,
        DocumentDetailsSectionAccessibilityComponent,
        DocumentDetailsDashboardAccessibilityComponent,
        DocumentDetailsSectionDashboardComponent,
        PageFixFormMarqueeComponent,
        PageFixFormBoldOptionsComponent,
        PageFixFormBoldComponent,
        PageFixFormBlinkOptionsComponent,
        PageFixFormBlinkComponent,
        PageFixFormItalicOptionsComponent,
        PageFixFormItalicComponent,
        PageFixFormCustomComponent,
        TablePageSizeComponent,
        TableSearchComponent,
        FilterButtonComponent,
        MonTabsComponent,
        VisitsComponent,
        LanguageComponent,
        PagesButtonComponent,
        AccessibilityTableFilterSelectorItemTemplateComponent,
        TableFiltersSelectorItemComponent,
        TableFiltersSelectorComponent,
        TableFiltersComponent,
        TableContainerPagerComponent,
        TableContainerComponent,
        TableSelectItemComponent,
        TableSelectItemAllComponent,
        FormFieldInputComponent,
        FormFieldCheckboxComponent,
        FormFieldCheckboxInLineComponent,
        FormFieldTextareaComponent,
        FormFieldSelectComponent,
        SelectCountriesComponent,
        SelectTimezonesComponent,
        FormFieldMaterialSwitchComponent,
        FormFieldRadioInLineComponent,
        FormFieldRadioNewLineComponent,
        TableDateComponent,
        TableComplianceComponent,
        MonPanelHeaderComponent,
        MonPanelComponent,
        UserDateComponent,
        DocumentsButtonComponent,
        IconCircleComponent,
        NotificationComponent,
        NotificationChangeComponent,
        NotificationTextComponent,
        MonSpinnerSnakeComponent,
        UrlTitleComponent,
        TablePageDetailsComponent,
        TableDocumentDetailsComponent,
        UrlTitlePageDetailsComponent,
        UrlTitleDocumentDetailsComponent,
        NotificationDropdownComponent,
        PagesTableComponent,
        MonChartDashboardComponent,
        TableCssComplianceComponent,
        LabelContainerSelectorComponent,
        LabelContainerComponent,
        LabelTableComponent,
        PagesFilesComponent,
        PagesFilesPagesComponent,
        IconButtonComponent,
        AccGuidelineDescriptionComponent,
        AccHelpCenterBtnComponent,
        AccResponsibilitiesComponent,
        FastTrackTableComponent,
        FastTrackInformationComponent,
        AccessibilityDialogsHelpCenterComponent,
        FastTrackDialogsPagesComponent,
        AccessibilityDialogsNewHelpCenterDecisionTreeComponent,
        AccessibilityDialogsNewHelpCenterComponent,
        AccDocPdfAccessibilityRemediationBtnComponent,
        AccDocPdfAccessibilityMultipleRemediationsBtnComponent,
        PageFixIconComponent,
        PageFixChangesetAccessibilityComponent,
        PageFixChangesetLinkComponent,
        PageFixChangesetSpellingComponent,
        AccessibilityFastTrackComponent,
        AccessibilityDashboardComplianceBarComponent,
        AccessibilityDashboardComplianceDoughnutProgressbarComponent,
        AccessibilityDashboardComplianceDoughnutComponent,
        AccessibilityDashboardComplianceComponent,
        AccessibilityDashboardPdfDoughnutComponent,
        AccessibilityDashboardDistributionComponent,
        AccessibilityDashboardPdfComponent,
        AccessibilityDashboardDoughnutComponent,
        AccessibilitySummaryLineChartComponent,
        AccessibilityDashboardNotificationsComponent,
        AccessibilityDashboardSummaryComponent,
        AccessibilityDashboardComponent,
        PagePerformanceScoreDoughnutChartComponent,
        PagePerformanceScoreIndicatorsComponent,
        PolicyInformationComponent,
        MonFlagIconComponent,
        BrokenTableComponent,
        MonSetBackgroundColorDirective,
        PageLinkDropdownComponent,
        TableDictionaryComponent,
        TableDictionaryAllComponent,
        PagesMisspellingsTableComponent,
        PageDetailsSectionsTabsComponent,
        SopButtonComponent,
        PageDetailsSectionAccessibilityInformationFastTrackComponent,
        PageDetailsSectionAccessibilityInformationContentComponent,
        DocumentDetailsAccessibilityInformationComponent,
        DocumentDetailsAccessibilityWcag20TableComponent,
        PageDetailsSectionAccessibilityInformationComponent,
        PageAccessibilityWcag20TableComponent,
        PageAccessibilityWcag20Component,
        PageAccessibilityWcag21Component,
        PageAccessibilityWcag22Component,
        PageDetailsSectionAccessibilityComponent,
        PageDetailsSectionDashboardBlocksOverviewComponent,
        PageDetailsDashboardChartsAccessibilityComponent,
        PageDetailsDashboardChartsPagePerformanceComponent,
        PageDetailsDashboardChartsPoliciesComponent,
        PageDetailsDashboardChartsQaComponent,
        PageDetailsDashboardChartsSeoComponent,
        PageDetailsSectionInventoryDashboardComponent,
        PageDetailsDashboardChartsStatisticsComponent,
        PageDetailsSectionDashboardComponent,
        PageDetailsSectionInventoryHeaderComponent,
        PageDetailsSectionInventoryIncominglinksComponent,
        PageDetailsSectionInventoryLinksComponent,
        PageDetailsSectionInventoryMetadataComponent,
        PageDetailsSectionInventoryComponent,
        PageDetailsSectionPagePerformanceComponent,
        PageDetailsPolicyInformationImageComponent,
        PageDetailsPolicyInformationComponent,
        PageDetailsPoliciesTableComponent,
        PageDetailsSectionPoliciesComponent,
        PageDetailsBrokenlinksTableComponent,
        PageDetailsSectionQaBrokenComponent,
        PageDetailsSectionQaIgnoredSpellComponent,
        PageDetailsSectionQaReadabilityComponent,
        PageDetailsSectionQaSpellComponent,
        PageDetailsSectionQaLanguageMatchComponent,
        PageDetailsSectionQaComponent,
        PageDetailsSeoPagesPagesDialogComponent,
        SeoInformationDuplicateH1Component,
        SeoInformationDuplicateTitleComponent,
        SeoInformationMissingAltComponent,
        SeoInformationMissingH1Component,
        SeoInformationMissingMetaDescriptionComponent,
        SeoInformationMissingMetaKeywordComponent,
        SeoInformationMissingSubheadlinesComponent,
        SeoInformationMissingTitleComponent,
        SeoInformationMultipleH1Component,
        SeoInformationNoFollowComponent,
        SeoInformationNoIndexComponent,
        SeoInformationTooLongMetaDescriptionComponent,
        SeoInformationTooLongUrlComponent,
        SeoInformationTooManyPageLinksComponent,
        SeoInformationTooShortMetaDescriptionComponent,
        SeoInformationInformationComponent,
        SeoInformationQuickHelpComponent,
        PageDetailsSeoInformationComponent,
        PageDetailsSeoTableComponent,
        PageDetailsSectionSeoComponent,
        PageDetailsSectionStatisticsSummaryComponent,
        PageDetailsSectionStatisticsTrafficSourcesComponent,
        PageDetailsDashboardChartsDataPrivacyComponent,
        PagePerformanceProfileDropdownComponent,
        PagePerformancePageDetailsDashboardComponent,
        PagePerformancePageDetailsOpportunitiesComponent,
        PagePerformancePageDetailsDiagnosticsComponent,
        PagePerformancePageDetailsHistoryComponent,
        StatisticsInformationComponent,
        StatisticsDistributionComponent,
        PageDetailsSectionStatisticsComponent,
        PageDetailsComponent,
        PageDetailsSectionDataPrivacyComponent,
        PageDetailsCookieAcceptanceRateComponent,
        PagePerformanceScoreLineChartComponent,
        PagePerformanceOpportunitiesByImpactComponent,
        PagePerformancePageDetailsLoadSequenceComponent,
        PagePerformancePageDetailsLoadTimesTrendComponent,
        DomainDashboardDataPrivacyComponent,
        PinDomainComponent,
        LoginComponent,
        ScanDetailsDialogComponent,
        JiraIssueButtonsComponent,
    ],
})
export class ComponentsModule {}
